import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import { AuthProvider, AuthContext } from './context/Authcontext';
import { useNavigate } from 'react-router-dom';
import './App.css';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route exact path="/" element={<LoginPage />} />
          <Route path="/iframe" element={<PrivateRoute component={IframePage} />} />
          <Route path="/admin" element={<AdminRoute component={AdminPage} />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { auth } = React.useContext(AuthContext);
  return auth ? <Component {...rest} /> : <Navigate to="/" />;
};

const AdminRoute = ({ component: Component, ...rest }) => {
  const { auth } = React.useContext(AuthContext);
  return auth && auth.role === 'admin' ? <Component {...rest} /> : <Navigate to="/" />;
};

const IframePage = () => {
  const { auth, logout } = React.useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="iframe-container">
      <iframe
        src={auth.iframe}
        title="User Iframe"
      ></iframe>
    </div>
  );
};

export default App;
